import React, { useEffect, useRef } from "react";
import "./SquareGrid.css";

const baseColor = "#75280f";
const highlightColor = "#EC9C26";

interface SquareGridProps {
  squares: number[][];
  index: number;
}

const SquareGrid: React.FC<SquareGridProps> = ({ squares, index }) => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  function drawSquare(
    ctx: CanvasRenderingContext2D,
    wh: number,
    x: number,
    y: number,
    color: string
  ) {
    const squareSz = (720 / wh) * 0.95;
    const padding = (720 / wh) * 0.05;
    const yMirrorOffset = 720 - squareSz; // Y is drawn top to bottom by default

    ctx.fillStyle = color;
    ctx.fillRect(
      x * (squareSz + padding) + padding / 2,
      yMirrorOffset - (y * (squareSz + padding) + padding / 2),
      squareSz,
      squareSz
    );
  }

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !squares.length || !squares[0].length) return;

    const wh = Math.max(squares.length, squares[0].length);
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    ctx.clearRect(0, 0, 720, 720);

    for (let i = 0; i < wh; i++) {
      for (let j = 0; j < wh; j++) {
        const color = squares[i][j] === 0 ? baseColor : highlightColor;
        drawSquare(ctx, wh, j, i, color);
      }
    }
  }, [index, squares]);

  return (
    <canvas
      className="SquareGrid"
      ref={canvasRef}
      width={720}
      height={720}
    />
  );
};

export default SquareGrid;


